import React from 'react'
import DOMPurify from 'dompurify'
import { Container, Description } from './styles'
import { LaboratoryTestCommentProperty } from '~/interfaces'

interface IProps {
  comment: LaboratoryTestCommentProperty
}

export const Comment = ({ comment }: IProps): JSX.Element => {
  const { description } = comment

  return (
    <Container data-testid="comment-property">
      <Description dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }} />
    </Container>
  )
}
